import { useContext } from "react";
import { ActionMenu, Button, GripVertical, Plus } from "../../../ui";
import FoodItemCard from "../FoodItemCard/FoodItemCard";
import { Context } from "../../../../context/Context";

export default function FoodSection({
  section,
  menu,
  role,
  selectedBranchId,
  expandedCard,
  setExpandedCard,
  selectedOptions,
  setSelectedOptions,
  isDragging,
  sectionDragProps,
  itemDragProps,
  dragItemId,
  onAddItem,
  sectionActions = [],
  itemActions,
  itemHandlers,
  labels,
  selectMode = false,
  selectedItemIds,
  onToggleSelect,
  itemSends,
  onOpenSendHistory,
  sendBlockFor,
}) {
  const { lang } = useContext(Context);
  const isArabic = lang === "ar";
  const editable = role.canWrite && menu.lifecycle !== "archived";

  return (
    <section className={`food-section ${isDragging ? "is-dragging" : ""}`} id={`food-section-${section._id}`} {...sectionDragProps}>
      <div className="food-section-header">
        <div className="food-section-title">
          <h2>
            {section.order}. {section.name?.ar || section.name?.en}
          </h2>
          {section.name?.en && <p>{section.name.en}</p>}
          <span className="food-section-count">
            {section.items.length} {isArabic ? "صنف" : "items"}
          </span>
        </div>

        <div className="food-section-controls">
          {editable && sectionDragProps?.draggable && (
            <Button type="button" variant="primary" appearance="soft" size="sm" rounded className="food-section-toolbar-btn food-section-drag-btn" icon={<GripVertical size={17} />} title={isArabic ? "اسحب لترتيب القسم" : "Drag to reorder"} aria-label={isArabic ? "اسحب لترتيب القسم" : "Drag to reorder"} />
          )}
          {editable && <Button type="button" variant="primary" appearance="soft" size="sm" rounded className="food-section-toolbar-btn" icon={<Plus size={16} />} title={labels.addItem} aria-label={labels.addItem} onClick={() => onAddItem(section)} />}
          <ActionMenu label={`${labels.sectionActions}: ${section.name?.ar || section.name?.en || ""}`} items={sectionActions} buttonClassName="food-section-toolbar-btn" />
        </div>
      </div>

      <div className="food-grid">
        {section.items.map((item) => {
          const cardKey = String(item._id);
          return (
            <FoodItemCard
              key={cardKey}
              item={item}
              menu={menu}
              role={role}
              selectedBranchId={selectedBranchId}
              cardKey={cardKey}
              expanded={expandedCard === cardKey}
              onToggleExpand={() => setExpandedCard(expandedCard === cardKey ? null : cardKey)}
              selectedOptions={selectedOptions}
              setSelectedOptions={setSelectedOptions}
              isDragging={dragItemId === String(item._id)}
              selectMode={selectMode}
              selected={Boolean(selectedItemIds?.has(cardKey))}
              onToggleSelect={onToggleSelect}
              sentTo={itemSends?.[cardKey]}
              onOpenSendHistory={onOpenSendHistory}
              sendBlock={selectMode && sendBlockFor ? sendBlockFor(item) : null}
              {...itemHandlers}
              actions={itemActions(section, item)}
              actionsLabel={`${labels.itemActions}: ${item.name?.ar || item.name?.en || ""}`}
              {...(itemDragProps ? itemDragProps(section, item) : {})}
            />
          );
        })}
      </div>
    </section>
  );
}
